import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance141vh6u7faopd as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.o26_1 = key;
        this.p26_1 = value;
      }
      m3() {
        return this.o26_1;
      }
      n3() {
        return this.p26_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.o26_1) + ', value=' + toString(this.p26_1) + ')';
      }
      hashCode() {
        var result = this.o26_1 == null ? 0 : hashCode(this.o26_1);
        result = imul(result, 31) + (this.p26_1 == null ? 0 : hashCode(this.p26_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.o26_1, other.o26_1))
          return false;
        if (!equals(this.p26_1, other.p26_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.s26_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.k1n('key', keySerializer.r1m());
          $this$buildSerialDescriptor.k1n('value', valueSerializer.r1m());
          return Unit_instance;
        });
      }
      r1m() {
        return this.s26_1;
      }
      t26(_this__u8e3s4) {
        return _this__u8e3s4.m3();
      }
      u26(_this__u8e3s4) {
        return this.t26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      v26(_this__u8e3s4) {
        return _this__u8e3s4.n3();
      }
      w26(_this__u8e3s4) {
        return this.v26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      x26(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.d27_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.k1n('first', keySerializer.r1m());
          $this$buildClassSerialDescriptor.k1n('second', valueSerializer.r1m());
          return Unit_instance;
        });
      }
      r1m() {
        return this.d27_1;
      }
      e27(_this__u8e3s4) {
        return _this__u8e3s4.ue_1;
      }
      u26(_this__u8e3s4) {
        return this.e27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      f27(_this__u8e3s4) {
        return _this__u8e3s4.ve_1;
      }
      w26(_this__u8e3s4) {
        return this.f27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      x26(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.v1r($this.j27_1, 0, $this.g27_1);
  var b = composite.v1r($this.j27_1, 1, $this.h27_1);
  var c = composite.v1r($this.j27_1, 2, $this.i27_1);
  composite.j1r($this.j27_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.z1r($this.j27_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.v1r($this.j27_1, 0, $this.g27_1);
        break;
      case 1:
        b = composite.v1r($this.j27_1, 1, $this.h27_1);
        break;
      case 2:
        c = composite.v1r($this.j27_1, 2, $this.i27_1);
        break;
      default:
        throw SerializationException().m1o('Unexpected index ' + index);
    }
  }
  composite.j1r($this.j27_1);
  if (a === get_NULL())
    throw SerializationException().m1o("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().m1o("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().m1o("Element 'third' is missing");
  return new (Triple())(a, b, c);
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.g27_1 = aSerializer;
        this.h27_1 = bSerializer;
        this.i27_1 = cSerializer;
        var tmp = this;
        tmp.j27_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.k1n('first', this.g27_1.r1m());
          $this$buildClassSerialDescriptor.k1n('second', this.h27_1.r1m());
          $this$buildClassSerialDescriptor.k1n('third', this.i27_1.r1m());
          return Unit_instance;
        });
      }
      r1m() {
        return this.j27_1;
      }
      k27(encoder, value) {
        var structuredEncoder = encoder.i1r(this.j27_1);
        structuredEncoder.a1t(this.j27_1, 0, this.g27_1, value.nt_1);
        structuredEncoder.a1t(this.j27_1, 1, this.h27_1, value.ot_1);
        structuredEncoder.a1t(this.j27_1, 2, this.i27_1, value.pt_1);
        structuredEncoder.j1r(this.j27_1);
      }
      s1m(encoder, value) {
        return this.k27(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      t1m(decoder) {
        var composite = decoder.i1r(this.j27_1);
        if (composite.y1r()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.y26_1 = keySerializer;
        this.z26_1 = valueSerializer;
      }
      a27(encoder, value) {
        var structuredEncoder = encoder.i1r(this.r1m());
        structuredEncoder.a1t(this.r1m(), 0, this.y26_1, this.u26(value));
        structuredEncoder.a1t(this.r1m(), 1, this.z26_1, this.w26(value));
        structuredEncoder.j1r(this.r1m());
      }
      s1m(encoder, value) {
        return this.a27(encoder, value);
      }
      t1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.r1m();
        var composite = decoder.i1r(descriptor);
        var tmp$ret$1;
        $l$block: {
          if (composite.y1r()) {
            var key = composite.v1r(this.r1m(), 0, this.y26_1);
            var value = composite.v1r(this.r1m(), 1, this.z26_1);
            tmp$ret$1 = this.x26(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.z1r(this.r1m());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.v1r(this.r1m(), 0, this.y26_1);
                break;
              case 1:
                value_0 = composite.v1r(this.r1m(), 1, this.z26_1);
                break;
              default:
                throw SerializationException().m1o('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().m1o("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().m1o("Element 'value' is missing");
          tmp$ret$1 = this.x26(key_0, value_0);
        }
        var result = tmp$ret$1;
        composite.j1r(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
